import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setUser } from "../features/user/userSlice";

const PersistGate = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const userDetail = sessionStorage.getItem("userDetail");
    if (userDetail) {
      dispatch(setUser(JSON.parse(userDetail)));
    }
  }, [dispatch]);

  return null;
};

export default PersistGate;
